import API, { INotifications } from "src/API/AmplifyAPIWrapper";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { IRootState } from "../../reducers/CombinedReducers";
import { IOCAPIError, IViolationModuleLean } from "@vmosolutions/oc-interfaces";
import AmplifyAPIWrapper from "src/API/AmplifyAPIWrapper";

/**
 * Run regulation validation on a single crew member.
 * @param crewId - ID of Crew Member to run regulation check for
 * @param endDate - Last datetime to use pairings from, going a year back
 */
export const runRegsValidation = (crewId: string, endDate: Date | number) => {
  return async (dispatch: ThunkDispatch<object, object, AnyAction>, getState: () => IRootState): Promise<void> => {
    const endTS = endDate instanceof Date ? endDate.getTime() : endDate;
    const notifs: INotifications = {
      dispatch,
      errorMessage: "Failed to run violations check.",
      infoMessage: "Starting violations check...",
      successMessage: "Violations check started!",
    };
    await API.Get<{ [key: string]: any }>(`/validate/${crewId}?dateTimeMs=${endTS}`, notifs);
  };
};

/**
 * Run regulation validation on a list of crew members.
 * @param crewIds - List of IDs of Crew Members to run regulations checks for
 * @param endDate - Last datetime to use pairings from, going a year back
 */
export const runRegsValidationBulk = (crewIds: string[], endDate: Date | number) => {
  return async (dispatch: ThunkDispatch<object, object, AnyAction>, getState: () => IRootState): Promise<void> => {
    const endTS = endDate instanceof Date ? endDate.getTime() : endDate;
    const notifs: INotifications = {
      dispatch,
      errorMessage: "Failed to run violations check",
      infoMessage: "Starting violations check...",
      successMessage: "Violations check started!",
    };

    await API.Get<{ [key: string]: any }>(
      `/validateBulk?${crewIds.map((id) => `crewId=${id}`).join("&")}&dateTimeMs=${endTS}`,
      notifs
    );
  };
};

/**
 *
 * @returns A list of available violation modules to add to a base assingment
 */
export const getAvailableViolationModules = async (): Promise<IViolationModuleLean[]> => {
  const response: IViolationModuleLean[] | IOCAPIError | null =
    await AmplifyAPIWrapper.Get<IViolationModuleLean[]>("/violations/modules");
  return response;
};
